import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import useImmersiveMenu from 'hb-react/shared/hooks/useImmersiveMenu';

const useHref = (whiteLabelURL, page) => {
  const { currentNetwork } = useDefaultAppContexts();
  const isImmersiveMenu = useImmersiveMenu({
    location: { pathname: page },
    network: currentNetwork,
  });

  return (
    whiteLabelURL ||
    (isImmersiveMenu ? `${window.location.origin}${page}` : page)
  );
};

export default useHref;
